import { browser } from '$app/environment';
import { PUBLIC_GA_ID } from '$env/static/public';

let analyticsInitialized = false;

export function initializeAnalytics() {
	if (!browser || !PUBLIC_GA_ID || analyticsInitialized) return;
	analyticsInitialized = true;

	// Load the gtag script
	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${PUBLIC_GA_ID}`;
	document.head.appendChild(script);

	// Initialize gtag
	window.dataLayer = window.dataLayer || [];
	// Per Google's gtag.js bootstrap snippet: dataLayer.push receives the
	// `arguments`-shaped object so the GA tag library can iterate positionally.
	// Preserve that semantic by pushing the rest-args array (functionally
	// equivalent — both are array-likes; GA's loader treats them uniformly).
	window.gtag = function gtag(...args: unknown[]) {
		// `window.dataLayer.push` is typed to expect `IArguments` (legacy gtag.js
		// signature). Spread the rest-args back so positional iteration works.
		(window.dataLayer.push as (...a: unknown[]) => number)(...args);
	};

	window.gtag('js', new Date());
	window.gtag('config', PUBLIC_GA_ID, {
		send_page_view: false // We'll handle page views manually
	});
}

// Track page views
export function trackPageView(url: URL) {
	if (!browser || !window.gtag || !PUBLIC_GA_ID) return;
	window.gtag('event', 'page_view', {
		page_path: url.pathname,
		page_location: url.href,
		page_title: document.title
	});
}

// Track events
export function trackEvent(eventName: string, parameters: Record<string, unknown> = {}) {
	if (!browser || !window.gtag || !PUBLIC_GA_ID) return;
	window.gtag('event', eventName, parameters);
}

// Track GA4 purchase event for revenue reporting
export function trackPurchase(params: {
	transaction_id: string;
	value: number;
	item_name: string;
	creator_id: string;
	image_type?: string;
	voices_used?: string[];
}) {
	const eventParams: Record<string, unknown> = {
		transaction_id: params.transaction_id,
		value: params.value,
		currency: 'USD',
		item_name: params.item_name,
		creator_id: params.creator_id
	};
	if (params.image_type) {
		eventParams.image_type = params.image_type;
	}
	if (params.voices_used && params.voices_used.length > 0) {
		eventParams.voices_used = params.voices_used.join(',');
	}
	trackEvent('purchase', eventParams);
}
